import TextField from '@atlassian/jira-portfolio-3-common/src/textfield/index.tsx';
import FieldDatePicker from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/component-slot-content/field-date-picker/index.tsx';

import FieldMultiSelectCell from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/component-slot-content/field-multi-select-cell/index.tsx';

import FieldUserAvatarCell from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/component-slot-content/field-user-avatar-cell/index.tsx';
import IssueSearchWarningClearFilter from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/component-slot-content/issue-search-warning-clear-filter/index.tsx';
import AdvancedFieldsMenu from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/fields/header/advanced-fields-menu/index.tsx';
import NowLine from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/timeline/now/index.tsx';
import type { Props } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/roadmap/types.tsx';
import { provideComponents } from '@atlassian/jira-portfolio-3-portfolio/src/common/component-slots/index.tsx';
import FilterDependencyGraphFromRoadmap from '@atlassian/jira-portfolio-3-portfolio/src/common/view/filter-dependency-graph-from-roadmap/index.tsx';
import QuickFilter from '@atlassian/jira-portfolio-3-portfolio/src/common/view/quick-filter/index.tsx';
import {
	AsyncSelectForColumnCell as FieldAsyncSelect,
	CellSelectWithRollup,
	SelectForColumnCell as FieldPrioritySelect,
	SelectForColumnCell as FieldSelect,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/select/index.tsx';
import UserPicker from '@atlassian/jira-portfolio-3-portfolio/src/common/view/user-picker/index.tsx';
import PlanReport from './main.tsx';

export default provideComponents<Props>({
	FieldSelect,
	FieldAsyncSelect,
	FieldPrioritySelect,
	FieldMultiSelectCell,
	FieldDatePicker,
	FieldUserAvatarCell,
	CellSelectWithRollup,
	CellTextField: TextField,
	AdvancedFieldsMenu,
	FilterDependencyGraphFromRoadmap,
	QuickFilter,
	IssueSearchWarningClearFilter,
	NowLine,
	UserPicker,
})(PlanReport);
